import axios from 'axios';
import { BASE_API_URL, PREFIX_API_PUBLIC } from '@/constants';
import { IPayment } from '@/shared/model/payment.model';
const entityName = 'payment';

export default class PaymentService {
  /**
   * Start payment
   * @param inscriptionId
   */
  public start(inscriptionId: string): Promise<IPayment> {
    return new Promise<IPayment>((resolve, reject) => {
      axios
        .post(`${BASE_API_URL}${PREFIX_API_PUBLIC}${entityName}/start`, inscriptionId, {
          headers: {
            'content-type': 'text/plain',
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * End payment
   * @param params
   */
  public end(params: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${BASE_API_URL}${PREFIX_API_PUBLIC}${entityName}/end`, params, {
          headers: {
            'content-type': 'text/plain',
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
